import React from 'react';
import { Box, InputBase, CircularProgress, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { useInstatDesign } from '../theme/instatDesign';

/**
 * iOS-style inset search bar. Rounded-full, soft inner gray.
 * onSubmit: called when user hits Enter.
 */
export default function SearchBar({
  value,
  onChange,
  onSubmit,
  placeholder = 'Search…',
  loading = false,
  autoFocus = false,
  sx = {},
}) {
  const d = useInstatDesign();
  const handleKey = (e) => {
    if (e.key === 'Enter' && onSubmit) onSubmit();
  };
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        bgcolor: 'rgba(120,120,128,0.12)',
        borderRadius: `${d.radius.pill}px`,
        px: 1.5,
        height: 38,
        minWidth: 260,
        transition: `background-color ${d.motion.fast}, box-shadow ${d.motion.fast}`,
        '&:focus-within': {
          bgcolor: d.colors.surface,
          boxShadow: `0 0 0 2px ${d.accentBorder}`,
        },
        ...sx,
      }}
    >
      <SearchIcon sx={{ fontSize: 16, color: d.colors.textSecondary }} />
      <InputBase
        value={value}
        onChange={(e) => onChange && onChange(e.target.value)}
        onKeyDown={handleKey}
        placeholder={placeholder}
        autoFocus={autoFocus}
        sx={{
          flex: 1,
          fontSize: 14,
          color: d.colors.text,
          fontFamily: d.typo.fontFamily,
          '& input::placeholder': {
            color: d.colors.textTertiary,
            opacity: 1,
          },
        }}
      />
      {loading ? (
        <CircularProgress size={14} sx={{ color: d.colors.textSecondary }} />
      ) : value ? (
        <IconButton
          size="small"
          onClick={() => onChange && onChange('')}
          sx={{ p: 0.25, color: d.colors.textTertiary }}
        >
          <CloseIcon sx={{ fontSize: 16 }} />
        </IconButton>
      ) : null}
    </Box>
  );
}
